<template>
    <div class="flex flex-col">
        <h3 v-html="affiliationFormTitle" class="pb-8"></h3>
        <template v-if="value && affiliation && affiliation.id == null">
            <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="translate('Would you like to create a new affiliation or to use an existing one?')"></label>
            <div class="mt-1 sm:mt-0 sm:col-span-2 pt-4">
                <select v-model="affiliationMode" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                    <option value="-1" v-html="translate('Please select one')"></option>
                    <option value="select" v-html="translate('Choose existing affiliation')"></option>
                    <option value="form" v-html="translate('Create a new affiliation')"></option>
                </select>

            </div>
        </template>
        <template  v-if="author != null && affiliation != null && affiliationMode == 'select'">
            <select v-model="assignExistingAffiliation"
                    class="mt-4 block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                <option v-html="translate('Please select one')" value="-1"></option>
                <field-display-option v-for="p, pIndex in participantAffiliations"
                                      :key="'k-'+p.id"
                                      :optionValue="p.id"
                                      :fields="participantAffiliationFieldvalues(pIndex)"
                                      :join="', '"
                                      :template-string="affiliationTemplateString"></field-display-option>
            </select>
        </template>
        <template  v-if="author != null && affiliation != null && (affiliationMode == 'form' || affiliation.id !== null)">
            <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                 v-for="field, index in affiliationfields"
            >
                <template v-if="field.valueset === null">
                    <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="field.label+mandatoryAsterisk(field)"></label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <input type="text" v-model="author.affiliations[affiliationIndex][field.field]" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                        <guideline :key="'gl-affiliation-'+field.field" :guidelinekey="'affiliation.'+field.field" :guidelines="guidelines"></guideline>

                    </div>
                    <div v-if="errors[field.field]" class="pt-2 text-red-500 sm:col-span-2" v-html="errors[field.field]"></div>
                </template>
                <template v-if="field.valueset !== null">
                    <label class="block text-sm text-gray-700 sm:mt-px sm:pt-2" v-html="field.label+mandatoryAsterisk(field)"></label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <select v-model="author.affiliations[affiliationIndex][field.field]" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md">
                            <option v-for="valuesetItem in field.valueset"
                                    :value="valuesetItem.value"
                                    v-html="valuesetItem.label"></option>
                        </select>
                        <guideline :key="'gl-affiliation-'+field.field" :guidelinekey="'affiliation.'+field.field" :guidelines="guidelines"></guideline>

                    </div>
                    <div v-if="errors[field.field]" class="pt-2 text-red-500 sm:col-span-2" v-html="errors[field.field]"></div>
                </template>
            </div>
        </template>
        <div v-if="errors['affiliationMode']" class="pt-2 text-red-500 sm:col-span-2" v-html="errors['affiliationMode']"></div>
        <div v-if="showButtons" class="pt-8 w-full flex items-center justify-between">
            <template v-if="affiliationMode != 'select'">
                <button v-if="affiliation && affiliation.authoraffiliations_count < 2" v-on:click="saveAffiliation" class="bg-customindigo text-indigo-700" v-html="translate('Save')"></button>
                <button v-if="affiliation && affiliation.authoraffiliations_count > 1" v-on:click="confirmMultipleAffiliations" class="bg-customindigo text-indigo-700" v-html="translate('Save')"></button>
            </template>
            <button v-if="affiliationMode == 'select'"
                    :disabled="assignExistingAffiliation < 1"
                    v-on:click="saveExistingAffiliation" class="bg-customindigo text-indigo-700" v-html="translate('Save')"></button>
            <button v-on:click="cancelAffiliationEditing" class="bg-gray-300" v-html="translate('Cancel')"></button>
        </div>
        <popup :visible="showMultipleAffiliationsConfirmation">
            <div class="py-8 w-full flex items-center justify-center" v-html="translate('The selected affiliation is assigned to more than one authors. Please select from the options below.')"></div>
            <div class="py-8 w-full flex flex-col items-center justify-center">
                <button v-on:click="saveAffiliation" class="bg-customindigo text-indigo-700 mb-4" v-html="translate('Save changes for everyone')"></button>
                <button v-on:click="cloneCurrentAffiliation" class="bg-customindigo text-indigo-700 mb-4" v-html="translate('Save changes only for this author')"></button>
            </div>
        </popup>
    </div>
</template>

<script>
    import FieldDisplayLabel from "./FieldDisplayLabel";
    import Guideline from "./Guideline";

    export default {
        components: {FieldDisplayLabel, Guideline},

        props: {
            value: {},
            affiliationfields: {},
            author: {},
            affiliationIndex: {},
            errors: {},
            resetflag: {},
            participantAffiliations: {},
            affiliationTemplateString: {},
            showButtons: {type: Boolean, default: true},
            guidelines: {type: Object}
        },
        inject: ['translate'],
        data: function () {
            return {
                affiliation: null,
                affiliationMode: -1,
                assignExistingAffiliation: -1,
                showMultipleAffiliationsConfirmation: false,
            }
        },
        mounted() {
            this.affiliation = {...this.value};
            this.emitAffiliationMode();
        },
        methods: {
            emitAffiliationMode: function() {
                this.$emit('affiliationmode', this.affiliationMode);
            },
            emitAssignedAffiliation: function() {
                this.$emit('assignedaffiliation', this.assignExistingAffiliation);
            },
            saveAffiliation: function() {
                this.$emit('saveaffiliation');
            },
            saveExistingAffiliation: function() {
                this.$emit('saveexistingaffiliation', this.assignExistingAffiliation);
            },
            deleteAffiliation: function() {
                this.$emit('deleteaffiliation');
            },
            cancelAffiliationEditing: function() {
                this.$emit('cancelaffiliationEditing');
            },
            cloneCurrentAffiliation: function() {
                this.$emit('clonecurrentaffiliation');
            },
            mandatoryAsterisk: function(field) {
                return field.mandatory === true ? '*' : '';
            },
            confirmMultipleAffiliations: function() {
                this.showMultipleAffiliationsConfirmation = true;
            },
            participantAffiliationFieldvalues: function(index) {
                let result = [];
                this.affiliationfields.forEach((f) => {
                    let i = {...f};
                    i.value = this.participantAffiliations[index][f.field];
                    result.push(i);
                });
                return result;
            },

        },
        computed: {
            affiliationFormTitle: function() {
                if (!this.affiliation) {
                    return '';
                }
                return this.affiliation.id === null
                    ? this.translate('Add affiliation')
                    : this.translate('Edit affiliation');
            },

        },
        watch: {
            value: function() {
                this.affiliation = {...this.value};
            },
            affiliationMode: function() {
                this.emitAffiliationMode();
            },
            assignExistingAffiliation: function() {
                this.emitAssignedAffiliation();
            },
            resetflag: function() {
                this.affiliationMode = -1;
                this.assignExistingAffiliation = -1;
                this.showMultipleAffiliationsConfirmation = false;
            }
        }

    }
</script>
